export const giftQuantityType = {
  limit: 'limit',
  noLimit: 'no-limit',
};

export const giftStatus = {
  PUBLIC: 'public',
  DRAFT: 'draft',
};
